const removeHoverClasses = (compAttr) => {

    const comp = () => document.querySelector(`[data-tooltip='${compAttr}']`)

    if(comp() !== null){
        comp().classList.remove('gjs-pn-btn4');
        comp().classList.add('gjs-pn-btn5');
        comp().removeAttribute('data-tooltip-pos');
    }

}

const removePanelsButtonHoverClasses = (editor,panelId, buttonId,classNames) => {

    editor.Panels.getButton(panelId,buttonId).set('className',`${classNames} gjs-pn-btn5`)
    editor.Panels.getButton(panelId,buttonId).set('attributes',{'data-tooltip': '', 'data-tooltip-pos': ''});

} 

const removePanelsButtonDeviceHoverClasses = (editor,panelId, buttonId,classNames) => {

    editor.Panels.getButton(panelId,buttonId).set('className',`${classNames} gjs-pn-btn5 gjs-pn-width`)
    editor.Panels.getButton(panelId,buttonId).set('attributes',{'data-tooltip': '', 'data-tooltip-pos': ''});

} 

const addPanelsButtonHoverClasses = (editor,panelId,buttonId,hoverMessage,classNames) => {

    editor.Panels.getButton(panelId,buttonId).set('className',`${classNames} gjs-pn-btn4`);
    editor.Panels.getButton(panelId,buttonId).set('attributes',{'data-tooltip': hoverMessage, 'data-tooltip-pos': 'bottom'});

}

const addPanelsDeviceButtonHoverClasses = (editor,panelId,buttonId,hoverMessage,classNames) => {

    editor.Panels.getButton(panelId,buttonId).set('className',`${classNames} gjs-pn-btn4 gjs-pn-width`);
    editor.Panels.getButton(panelId,buttonId).set('attributes',{'data-tooltip': hoverMessage, 'data-tooltip-pos': 'bottom'});

}


const addHoverClasses = (compAttr) => {

    const comp = () => document.querySelector(`[data-tooltip='${compAttr}']`);
    if(comp() !== null) {
        comp().classList.remove('gjs-pn-btn5');
        comp().classList.add('gjs-pn-btn4');
        comp().setAttribute('data-tooltip-pos','bottom');
    } 

}




const preventRunCommands = (editor) => {

    editor.on('run:view-annotations', () => {
        removeHoverClasses('New page');
        removeHoverClasses('Delete page');
        removeHoverClasses('Save page');
        removeHoverClasses('Rename page');
        removeHoverClasses('Duplicate page');
        removeHoverClasses('Hide menu');
        removeHoverClasses('Expand menu');
        
        removePanelsButtonHoverClasses(editor,'basic-actions','clear-canvas','fas fa-broom');
        removePanelsButtonHoverClasses(editor,'basic-actions','apply-same-styling','fas fa-palette');
        removePanelsButtonHoverClasses(editor,'basic-actions','undo','fa fa-undo');
        removePanelsButtonHoverClasses(editor,'basic-actions','redo','fa fa-repeat');
        removePanelsButtonHoverClasses(editor,'basic-actions','fullscreen1','fa fa-expand');
        removePanelsButtonHoverClasses(editor,'basic-actions','export1','fas fa-file-export');
        removePanelsButtonHoverClasses(editor,'basic-actions','preview1','fa fa-eye fa-eye3');
        removePanelsButtonHoverClasses(editor,'enable_dragMode','enable_dragMode1','fa fa-arrows-alt fa-arrows-alt3');

        removePanelsButtonDeviceHoverClasses(editor,'device_manager','cmdDeviceDesktop','fa fa-desktop ');
        removePanelsButtonDeviceHoverClasses(editor,'device_manager','cmdDeviceTablet','fa fa-tablet ');
        removePanelsButtonDeviceHoverClasses(editor,'device_manager','cmdDeviceMobile','fa fa-mobile ');
 
    });

    editor.on('stop:view-annotations', () => {
        addHoverClasses('New page');
        addHoverClasses('Delete page');
        addHoverClasses('Save page');
        addHoverClasses('Rename page');
        addHoverClasses('Duplicate page');
        addHoverClasses('Hide menu');
        addHoverClasses('Expand menu');

        addPanelsButtonHoverClasses(editor,'basic-actions','clear-canvas','Clear canvas','fas fa-broom');
        addPanelsButtonHoverClasses(editor,'basic-actions','apply-same-styling','Apply styling','fas fa-palette');
        addPanelsButtonHoverClasses(editor,'basic-actions','undo','Undo','fa fa-undo');
        addPanelsButtonHoverClasses(editor,'basic-actions','redo','Redo','fa fa-repeat');
        addPanelsButtonHoverClasses(editor,'basic-actions','fullscreen1','Fullscreen','fa fa-expand');
        addPanelsButtonHoverClasses(editor,'basic-actions','export1','Export code','fas fa-file-export');
        addPanelsButtonHoverClasses(editor,'basic-actions','preview1','Preview','fa fa-eye fa-eye3');
        addPanelsButtonHoverClasses(editor,'enable_dragMode','enable_dragMode1','Enable absolute movement','fa fa-arrows-alt fa-arrows-alt2')

        addPanelsDeviceButtonHoverClasses(editor,'device_manager','cmdDeviceDesktop','Desktop device','fa fa-desktop');
        addPanelsDeviceButtonHoverClasses(editor,'device_manager','cmdDeviceTablet','Tablet device','fa fa-tablet');
        addPanelsDeviceButtonHoverClasses(editor,'device_manager','cmdDeviceMobile','Mobile device','fa fa-mobile');

    });

}


export default preventRunCommands;